import { BundleModifyTypes, PurchaseTypes } from "../app/shared/types/flows-config.types";
import { BundleEditionTypes } from "../app/shared/types/order.type";

const base_api = "https://petwants.navego.tech";

export const environment = {
  production: true,
  apis: {
    v1: `${base_api}`,
    v2: `${base_api}/api/v2`,
    v3: `${base_api}/api/v3`,
    google: {
      places: 'AIzaSyBTHTviZ7QPtEjH29Jmmkp13RO8LPrxppM'
    },
    firebase: {
      apiKey: "AIzaSyAonV8KLXVS-bY_zqJrwuY5lgjoyrqQkLY",
      authDomain: "pp-pet-wants.firebaseapp.com",
      projectId: "pp-pet-wants",
      storageBucket: "pp-pet-wants.firebasestorage.app",
      messagingSenderId: "233865426891",
      appId: "1:233865426891:web:5ba2da734acc1cca8fa84e",
      measurementId: "G-E3PM66QC1L"
    },
    klaviyo: {
      publicApiKey: 'QV6tBM'
    },
    maintenance: {
      url: 'https://ecommerce-configurations.navego.tech/api/v3/maintenance?url=petwants'
    },
    authorize: {
      APILoginID: '2E9Hq8qL',
      PublicClientkey: '7mc4E3ZANHKgrxjUC6Q4sj4RZ4dL2dQ2yR3H8hFDG3s4k3A4uPg4d42uXf4aBt9J'
    },
    turnstile: {
      // Cloudflare Turnstile, guarding the forms that can reach the gateway:
      // explorer creation, signup, the payment-method forms and the gift-card
      // purchase (DEV-11124). Public by design — the secret that validates the
      // token lives only in the backend.
      //
      // An empty key disables the check entirely: the widget is never rendered
      // and no token is sent.
      //
      // The order between the two sides is not symmetric, and this is the safe
      // half of it. The front going first is harmless: a token the backend is
      // not checking is ignored. The backend going first is not — its
      // `turnstile_secret_key` set against an empty site key answers 400
      // `captcha_required` to signup, the payment-method forms and the
      // gift-card purchase, which looks exactly like a frontend bug.
      //
      // So this key ships first and the backend's secret follows, never the
      // other way round. The widget has to list petwantscincy.com AND
      // www.petwantscincy.com, or it hands out no token on one of them.
      siteKey: '0x4AAAAAAFY5AHtl9ilNPg5Q'
    }
  },
  application: {
    angular: 'Angular 19.2.6',
    bootstrap: 'Bootstrap 5.3.2',
    fontawesome: 'Font Awesome 6.5.1',
    name: 'Pet Wants',
    version: '1.0.0',
  },
  config: {
    bodyClass: 'app-me',
    flows: {
      territories: false,
      membership: true,
      settings: {
        toHide: {
          membership: 'Membership'
        },
        profile: {
          hasPickupLocationsFlow: true
        },
        deliveryDayUpdates: {
          displayOnlyActiveReescheduledOrder: true
        }
      },
      specialMembership: {
        defaultRoute: '/order/custom-box/' + BundleEditionTypes.subscription,
        settings: {
          hideHeaderCategoriesNav: true
        },
      },
      order: {
        askForDonationOnSkip: false,
        showFreeDeliverySlider: false,
        voluntaryDonationFlow: false,
        showProductStatusTag: false,
        hasDriveTipsFlow: false,
      },
      bundles: {
        modifyType: BundleModifyTypes.outOfOrder
      },
      shop: {
        validateMarketState: true
      },
      login: {
        tempResetPassword: true
      },
      purchase: {
        type: PurchaseTypes.anet
      },
      signup: {
        // The signup will not advance until the address is proved through the
        // emailed link, so this needs `POST /signup/verification` to exist.
        //
        // On deliberately ahead of the backend (16 Oct 2026): their release
        // follows ours, and the call is to ship the whole thing in one deploy
        // rather than flip flags afterwards. Until theirs lands the endpoint
        // answers 404 and the signup cannot leave step 1, so the two deploys
        // belong back to back.
        requiresEmailVerification: true
      },
      welcomePage: {
        categoryToFetch: 10
      },
      /** Explorer (anonymous shopper) flow — DEV-11262.
       *
       *  Á Table has no flag for this: there the flow switches itself on purely
       *  because the server starts returning the explorer flags. Pet Wants
       *  gates it instead, so a late backend is a flag flip rather than a revert.
       *
       *  On deliberately ahead of the backend (16 Oct 2026), by the same call as
       *  the verification above. Note what this flag moves: the check-address
       *  modal stops handing off to `/signup` and offers "Start Shopping"
       *  against `POST /explorer`. That modal is the way into the shop, so
       *  while the endpoint is still 404 the shop has no entrance. The two
       *  deploys belong back to back. */
      explorer: {
        enabled: true
      }
    },
    filesVersionNumber: {
      logo: 2
    },
    friendReferral: {
      baseUrl: 'https://www.petwantscincy.com/signup?utm_source=friend_referral&utm_medium=share&utm_campaign='
    },
    seo: {
      mainTitle: 'Pet Wants Cincinnati | Fresh, Natural Pet Food & Supplies in Cincinnati, OH',
      mainDescription: 'Pet Wants Cincinnati offers fresh, nutritious pet food and natural products for your furry friends. Locally made, always fresh, and delivered to your door in Cincinnati.',
      baseTitle: 'Pet Wants Cincinnati',
      baseKeywords: ['Fresh', 'Pet', 'Food', 'Cincinnati', 'Natural pet products', 'Pet food delivery Cincinnati', 'Holistic pet care', 'Local pet store Cincinnati'],
      type: 'website',
      baseURL: 'https://petwantscincy.com/'
    },
    contactEmail: 'delivery@petwantscincy.com'
  },
};
